import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { IPopupComponentProps } from '../PopupComponent.h'

import {
  CancelSecondaryOpacityButton,
  PrimarySubmitButton,
} from 'atoms/Button/Templates'
import {
  TextBoxMaxLine2FontSm,
  TextBoxMaxLine3Font2XlBold,
} from 'atoms/TextBox/Templates'
import { ButtonGroup } from 'blocks/ButtonGroup'
import { TextBlock, TextBlockRowGap } from 'blocks/TextBlock'
import { PopupComponent } from '../PopupComponent'
import {
  SignInToWatchPopupBodySC,
  SignInToWatchPopupSC,
} from './SignInToWatchPopup.styled'

export interface ISignInToWatchPopupProps extends Omit<
  IPopupComponentProps,
  'children'
> {
  title: ITextBoxProps['title']
  buttonText: ITextBoxProps['title']
  cancelButtonText: ITextBoxProps['title']
  onSubmit?: () => void
  children: React.ReactNode
}

export const SignInToWatchPopup = ({
  title,
  buttonText,
  cancelButtonText,
  onSubmit,
  onClosePopup,
  withCloseButton = true,
  withGradientScrollableBlock = true,
  children,
  ...rest
}: ISignInToWatchPopupProps): JSX.Element => (
  <SignInToWatchPopupSC>
    <PopupComponent
      withCloseButton={withCloseButton}
      withGradientScrollableBlock={withGradientScrollableBlock}
      onClosePopup={onClosePopup}
      {...rest}
    >
      <TextBlock rowGap={TextBlockRowGap.INDENT_20}>
        <TextBoxMaxLine3Font2XlBold title={title} />

        <TextBoxMaxLine2FontSm>{children}</TextBoxMaxLine2FontSm>
      </TextBlock>

      <SignInToWatchPopupBodySC />

      <ButtonGroup>
        <PrimarySubmitButton title={buttonText} onClick={onSubmit} />

        <CancelSecondaryOpacityButton
          title={cancelButtonText}
          onClick={onClosePopup}
        />
      </ButtonGroup>
    </PopupComponent>
  </SignInToWatchPopupSC>
)
